// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"d374ed84","343":"711519eb","698":"45fc07f7","702":"a01b3c07","914":"89be5aa6"}[chunkId] + ".chunk.js";
};